import { QrFieldSource } from 'editor/src/store/design/types';

export type GetLinkedText = (elementId: number) => string | undefined;
export type GetColumnValue = (column: string) => string | undefined;

/**
 * The raw value a QR field source stands for. A column source with no resolver
 * reads as empty: a caller that cannot see the code set (a host that never
 * bound one) must not encode the column's name as if it were its value.
 */
function resolveQrFieldSource(
  source: QrFieldSource,
  getLinkedText: GetLinkedText,
  getColumnValue?: GetColumnValue,
): string | undefined {
  switch (source.type) {
    case 'static':
      return source.value;
    case 'element':
      return getLinkedText(source.elementId);
    case 'column':
      return getColumnValue?.(source.column);
    default:
      return undefined;
  }
}

export default resolveQrFieldSource;
